import { ConfirmDialog } from "~/ui/common/Modal/ConfirmDialog";

export const CloseConfirmationDialog = ({
  show,
  onConfirm,
  onCancel,
}: {
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) => (
  <ConfirmDialog
    show={show}
    title="Are you sure you want to close?"
    description="The information entered for this booking will be lost."
    confirmLabel="Close"
    onConfirm={onConfirm}
    onCancel={onCancel}
  />
);
